import PaintPurchaseRequestsWorkspace from '../../placeholders/PaintPurchaseRequestsWorkspace';

export default PaintPurchaseRequestsWorkspace;
